import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary-100 flex items-center justify-center">
          <i className="ri-compass-3-line text-3xl text-primary-600"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading text-foreground-900 mt-6">
          页面未找到
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-500 max-w-md mx-auto">
          您访问的页面可能已被移除或暂时不可用。请返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-xl text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}